import NextImage from 'next/image';

import { Impression } from '@benzinga/analytics';

const variants = {
  'insider-report': {
    title: "3 Weekly Trades From The 'Insider Report'",
    description:
      "Get a headstart on the markets every Sunday with expert analysis and three stocks to buy! The 'Insider Report' gives you exactly which market catalysts and major news events might be driving markets each week. Get immediate access with a Benzinga Edge membership!",
    url: 'https://www.benzinga.com/premium/ideas/benzinga-edge/?utm_campaign=commandcenter&adType=mystocks&ad=insiderreport',
    asset: '/next-assets/images/portfolio/insider-report-end.png',
    gapClass: 'md:gap-20',
    mobileAssetOffset: 'max-md:-mr-64',
    mobileCopyPad: 'max-md:pr-10',
  },
  'whisper-index': {
    title: "Get the 5 Stock Weekly 'Whisper Index'",
    description: (
      <>
        Exclusive for Benzinga Edge members! The Weekly Whisper Index reveals{' '}
        <strong>
          <u>five under-the-radar stocks gaining</u>
        </strong>{' '}
        investor attention. Get access to these under-followed stocks with potential to move plus a
        host of other tools and research by joining Benzinga Edge.{' '}
      </>
    ),
    url: 'https://www.benzinga.com/premium/ideas/benzinga-edge/?utm_campaign=commandcenter&adType=mystocks&ad=whisperindex',
    asset: '/next-assets/images/portfolio/whisper-index-end.png',
    gapClass: 'md:gap-36',
    mobileAssetOffset: 'max-md:-mr-[300px]',
    mobileCopyPad: 'max-md:pr-14',
  },
};

export const EdgeBanner = ({ type = 'insider-report' }: { type: keyof typeof variants }) => {
  const variant = variants[type];

  return (
    <Impression campaign_id="portfolio-edge-cta" unit_type={type}>
      <div
        className={`relative z-10 flex flex-col justify-between overflow-hidden rounded-lg bg-gradient-to-b from-[#0c1c33] to-[#050e18] p-8 md:flex-row ${variant.gapClass}`}
      >
        <div className="pointer-events-none absolute left-0 top-0 h-full w-[400px]">
          <NextImage
            src="/next-assets/images/portfolio/bg-start.png"
            width={400}
            height={200}
            alt="Benzinga Edge Banner"
            className="h-full w-full object-cover"
            priority
          />
        </div>
        <div className="relative z-[1]">
          <div className="mb-4">
            <NextImage
              src="/next-assets/images/portfolio/edge-logo.png"
              height={40}
              width={200}
              alt="Benzinga Edge Logo"
              priority
            />
          </div>
          <div className={variant.mobileCopyPad}>
            <h3 className="mb-4 text-[30px] font-bold leading-9 text-white md:text-4xl md:leading-10">
              {variant.title}
            </h3>
            <p className="max-w-[700px] text-sm leading-6 text-bzblue-400 md:text-base md:leading-[27px]">
              {variant.description}
            </p>
          </div>
        </div>
        <a
          href={variant.url}
          target="_blank"
          rel="noopener noreferrer"
          className="relative z-[1] mt-4 self-start whitespace-nowrap rounded-lg bg-bzblue-600 px-10 py-4 text-lg font-bold uppercase text-[#f2f8ff] hover:bg-[#2e6be6] md:mt-0 md:self-end"
        >
          get started
        </a>
        <div
          className={`pointer-events-none absolute bottom-0 right-0 h-[300px] w-[450px] bg-cover bg-right-bottom bg-no-repeat ${variant.mobileAssetOffset}`}
        >
          <NextImage
            src={variant.asset}
            height={300}
            width={450}
            alt="Benzinga Edge Banner"
            className="h-full w-full object-cover object-right-bottom"
            priority
          />
        </div>
      </div>
    </Impression>
  );
};

export default EdgeBanner;
